import {FirebaseService} from "@/services/firebase/FirebaseService";
import {logEvent} from "firebase/analytics";
import LogService from "@/services/log-service/LogService";
import {FirebaseEvents} from "@/services/firebase/analytics/FirebaseEvents";
import FirebaseEventBuilder from "@/services/firebase/analytics/FirebaseEventBuilder";

export default class FirebaseWrongRangeSuccessMetric {
    private _firebaseService: FirebaseService;
    private _observe: boolean = false;

    public constructor(firebaseService: FirebaseService) {
        this._firebaseService = firebaseService;
    }

    get observe(): boolean {
        return this._observe;
    }

    public startObserve() {
        this._observe = true;
        LogService.of().log("FirebaseWrongRangeSuccessMetric@startObserve", null);
    }

    public checkAndSendAnalyticEvent() {
        if (this._observe) {
            FirebaseService.of().analyticsEvent(
                FirebaseEvents.PAYMENT_ERROR_WRONG_RANGE_SUCCESS,
                FirebaseEventBuilder.of().build()
            );
            this.reset();
        }
    }

    public reset() {
        LogService.of().log("FirebaseWrongRangeSuccessMetric@reset", null);
        this._observe = false;
    }
}